import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { MESSAGE_MODALS } from '../../../context/custom/MessageModalContext';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, } from '../../common';
import { getDateToString, getFormatNumber  } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import SuperficieModal from '../SuperficieModal';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { isNull } from '../../../utils/validator';
import { useManagedContext } from '../../hooks';
import {TIPS} from "../../../consts/tips";

const SuperficiesGrid = (props) => {
  const { showMessageModal } = useManagedContext();

  //#region Hooks
  const [state, setState] = useState({
      idInmueble: 0,
      disabled: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
        showModal: false,
        idEntidad: null
      },      
      list: []
  });

  const [superficies, setSuperficies] = useState([]);

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r');
      return {...prevState,
        idInmueble: props.data.idInmueble,
        list: list };
    });
  }
  useEffect(mount, [props.data]);

  const [, getRowEntidad] = useEntidad({
    entidades: ['TipoSuperficie'],
    onLoaded: (entidades, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoSuperficie',
      timeout: 0
    }
  });
  //#endregion


  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickSuperficieAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickSuperficieView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickSuperficieModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickSuperficieRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickSuperficieDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>
                              </div>

  const getDescTipoSuperficie = (id) => {
    const row = getRowEntidad('TipoSuperficie', id);
    return (row) ? row.nombre : '';
  }

  const tableColumns = [
    { Header: 'Número', accessor: 'nroSuperficie', width: '10%' },
    { Header: 'Tipo superficie', Cell: (props) => getDescTipoSuperficie(props.value), accessor: 'idTipoSuperficie', width: '40%' },
    { Header: 'Metros', Cell: (props) => getFormatNumber(props.value,2), accessor: 'metros', width: '10%', alignCell: 'right' },
    { Header: 'Plano', accessor: 'plano', width: '20%' },
    { Header: 'Vigencia', Cell: (data) => (data.value) ? getDateToString(data.value, false) : '', accessor: 'fechaVigenteDesde', width: '10%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];

  //#region Handles
  const handleClickSuperficieAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idInmueble: state.idInmueble,
        nroSuperficie: "",
        nroInterno: "",
        nroDeclaracionJurada: "",
        idTipoSuperficie: 0,
        metros: 0,
        plano: "",
        idGrupoSuperficie: 0,
        idTipoObraSuperficie: 0,
        idDestinoSuperficie: 0,
        fechaIntimacion: null,
        nroIntimacion: "",
        nroAnterior: "",
        fechaPresentacion: null,
        fechaVigenteDesde: null,
        fechaRegistrado: null,
        fechaPermisoProvisorio: null,
        fechaAprobacion: null,
        conformeObra: false,
        fechaFinObra: null,
        ratificacion: "",
        derechos: "",
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    setSuperficies(state.list.map(x => x.nroSuperficie));
    dispatch( sequenceActionNext() );
  }
  const handleClickSuperficieView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickSuperficieModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    setSuperficies(state.list.filter(x => x.id !== id).map(x => x.nroSuperficie));
  }
  const handleClickSuperficieRemove = (id) => {
    const superficie = state.list.find(x => x.id === id);
    showMessageModal({
      ...MESSAGE_MODALS.BORRAR,
      message: `¿Está seguro de borrar la superficie ${superficie.nroSuperficie}?`,
      onConfirm: () => {
        props.onChange('Superficie', { ...superficie, state: 'r' })
      }
    })
  }

  const handleClickSuperficieDataTagger = (id) => {
    setState(prevState => {
      return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
    });
  }
  //#endregion

  //funciones
  function UpdateSuperficie(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('Superficie', row);
  }

  return (
  <>

    {state.dataTagger.showModal &&
      <DataTaggerModalRedux
          title="Información adicional de superficie"
          tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_SUPERFICIE_MODAL}
          processKey={props.processKey}
          entidad="Superficie"
          idEntidad={state.dataTagger.idEntidad}
          disabled={props.disabled}
          onDismiss={() => {
            setState(prevState => {
              return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
            });
          }}
      />
    }

    {state.showForm && 
        <SuperficieModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm,
              listSuperficies: superficies
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateSuperficie(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

SuperficiesGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

SuperficiesGrid.defaultProps = {
  disabled: false
};

export default SuperficiesGrid;